<div class="container-fluid mt-3">
  <h2 class="mb-1">{{'HELP.EDITOR_TITLE' | translate}}</h2>
  <p class="editor-lede">{{'HELP.EDITOR_LEDE' | translate}}</p>

  <nav ngbNav #nav="ngbNav" class="nav-tabs" [destroyOnHide]="false">

    <!-- ── The cards ──────────────────────────────────────────────────── -->
    <ng-container ngbNavItem>
      <a ngbNavLink>{{'HELP.TAB_CARDS' | translate}}</a>
      <ng-template ngbNavContent>

        <div class="d-flex flex-wrap align-items-center gap-2 mt-4 mb-3">
          <button type="button" class="btn btn-primary" (click)="saveCards()" [disabled]="savingCards">
            {{'ADMIN.SAVE' | translate}}
          </button>
          <button type="button" class="btn btn-outline-secondary" (click)="resetAll()">
            {{'HELP.RESET_ALL' | translate}}
          </button>
          <span class="editor-note">{{'HELP.EDITED_COUNT' | translate:{ count: editedCount } }}</span>
        </div>

        <!--
          Every card, every offered language, on one page. An administrator
          editing help is comparing translations of the same sentence, so
          putting the languages side by side is the whole point: a French card
          that no longer says what the English one says is visible here and
          nowhere else.
        -->
        @for (card of cards; track card.id) {
          <fieldset class="editor-card">
            <legend class="editor-card-legend">
              <lucide-icon [name]="card.icon" size="16"></lucide-icon>
              <span>{{card.title.en}}</span>
              <span class="editor-badge">{{('HELP.CATEGORY.' + (card.category | uppercase)) | translate}}</span>
              @if (isEdited(card.id)) {
                <span class="editor-badge editor-badge--edited">{{'HELP.EDITED' | translate}}</span>
              }
            </legend>

            @for (lang of languages; track lang) {
              <div class="editor-lang">
                <div class="editor-lang-name">{{('ADMIN.LANGUAGE_' + (lang | uppercase)) | translate}}</div>

                <div class="mb-2">
                  <label class="form-label" [attr.for]="card.id + '-title-' + lang">
                    {{'HELP.FIELD_TITLE' | translate}}
                  </label>
                  <input type="text" class="form-control" maxlength="120"
                         [id]="card.id + '-title-' + lang"
                         [name]="card.id + '-title-' + lang"
                         [ngModel]="card.title[lang]"
                         (ngModelChange)="setText(card, 'title', lang, $event)">
                </div>

                <div>
                  <label class="form-label" [attr.for]="card.id + '-body-' + lang">
                    {{'HELP.FIELD_BODY' | translate}}
                  </label>
                  <textarea class="form-control" rows="4" maxlength="2000"
                            [id]="card.id + '-body-' + lang"
                            [name]="card.id + '-body-' + lang"
                            [ngModel]="card.body[lang]"
                            (ngModelChange)="setText(card, 'body', lang, $event)"></textarea>
                </div>
              </div>
            }

            <div class="mt-2">
              <button type="button" class="btn btn-outline-secondary btn-sm"
                      (click)="resetCard(card.id)" [disabled]="!isEdited(card.id)">
                {{'HELP.RESET_CARD' | translate}}
              </button>
              <div class="form-text">{{'HELP.RESET_CARD_HELP' | translate}}</div>
            </div>
          </fieldset>
        }

        <button type="button" class="btn btn-primary mb-4" (click)="saveCards()" [disabled]="savingCards">
          {{'ADMIN.SAVE' | translate}}
        </button>

      </ng-template>
    </ng-container>

    <!-- ── The older free-text block, kept ────────────────────────────── -->
    <ng-container ngbNavItem>
      <a ngbNavLink>{{'HELP.TAB_NOTES' | translate}}</a>
      <ng-template ngbNavContent>

        <p class="editor-note mt-4">{{'HELP.NOTES_HELP' | translate}}</p>

        @if (!loaded) {
          <div class="spinner-border" role="status"><span class="sr-only"></span></div>
        }

        @if (loaded) {
          <app-template-editor [elementId]="'helpEditorId'" [height]="'45vh'" style="z-index:0"
            (onEditorKeyup)="keyupHandlerFunction($event)" [tempValue]="data">
          </app-template-editor>
        }
        <br/>
        <button class="btn btn-primary" (click)="save()" [disabled]="!loaded">
          {{ 'ADMIN.SAVE' | translate }}
        </button>

        <hr/>
        <h5>{{ 'ADMIN.ATTACHMENTS' | translate }}</h5>

        <input type="file" #fileInput style="display:none" multiple
          accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,image/*"
          (change)="onFilesSelected($event)">

        <button class="btn btn-outline-secondary btn-sm mb-2" (click)="fileInput.click()">
          + {{ 'ADMIN.ATTACH_FILE' | translate }}
        </button>

        @if (documents.length > 0) {
          <table class="table table-sm">
            <thead>
              <tr>
                <th>{{ 'ADMIN.FILE_NAME' | translate }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (doc of documents; track doc) {
                <tr>
                  <td>{{ doc.originalname }}</td>
                  <td class="text-end">
                    <button class="btn btn-sm btn-outline-secondary me-1" (click)="downloadDocument(doc)">
                      {{ 'ADMIN.DOWNLOAD' | translate }}
                    </button>
                    <button class="btn btn-sm btn-outline-primary me-1" (click)="insertLink(doc)">
                      {{ 'ADMIN.INSERT_LINK' | translate }}
                    </button>
                    <button class="btn btn-sm btn-outline-danger" (click)="deleteDocument(doc)">
                      {{ 'ADMIN.DELETE' | translate }}
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }

      </ng-template>
    </ng-container>
  </nav>

  <div [ngbNavOutlet]="nav"></div>
</div>
